






























































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Workspace, Summary, ReviewForm } from '@/entities';
import ProgressBar from '@/components/common/ProgressBar/ProgressBar.vue';
import WorkflowButtons from '@/components/common/ProgressBar/WorkflowButtons.vue';
import NegotiationLog from '@/components/App/Modules/GMS/Applicant/Summary/NegotiationLog.vue';
import { http } from '@/shared/https';
import { Utilities as utils } from '@/shared/utilities';
import {AppConstants as _app} from '@/shared/app.constants';
import { Locales } from "@/i18n/locales";

const namespace: string = "application";

@Component({
    components: {
        ProgressBar,
        WorkflowButtons,
        NegotiationLog
    }
})
export default class ReviewApplicationSummaryComponent extends Vue {

    @State(namespace) application!: Workspace;
    @State("reviewForm") review!: ReviewForm;
    @Action("getData", { namespace: "reviewForm" }) getData: any;
    @Action("getCategories", { namespace: "reviewForm" }) getCategories: any;
    @Getter("rootTemplate", { namespace }) schema: any;
    @Action("getApplication", { namespace }) getApplication: any;
    @Action("getApplicationStatus", { namespace }) getApplStatus: any;
    @Action("saveApplication", { namespace: "application" }) save: any;
    @Action("setReviewId", { namespace: "reviewExternal" }) setReviewId: any;
    @Action("setApplicationId", { namespace: "application" }) setApplication: any;
    @Getter("_appUser", { namespace: "RootApp"}) _username!: string;
    @Getter("_appUserId", { namespace: "RootApp"}) _userid!: number;
    @Action("create", { namespace: "reviewForm" }) createReview: any;

    showFlow = false;
    tagReviews = [];
    id: number =  0;
    actions = _app.actions;
    subjects = _app.subjects;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    tagLockedStatus: any = [_app.reviewStatus.Submitted, _app.reviewStatus.COI_Rejected];
    tagDownloadStatus: any = [_app.reviewStatus.In_Progress, _app.reviewStatus.Submitted];

    mounted(){
        if (!this.application || !this.application.selectedApplication) {
            this.$router.push({
            name: "dashboard"
            });
        }
    }

    openReview(item: any) {
        // this.setReviewId(item.externalReviewId);
        let routeData = this.$router.resolve({
            name: "viewTagReview",
            query: { appReviewId: item.ExternalReviewId }
            });
        window.open(routeData.href, "_blank");
    }

    /** open a read only view of application in new tab */
    openApplication(applicationId, context) {
        if (context === "readonly") {
            let routeData = this.$router.resolve({
              name: "viewApplication",
              params: { appId: applicationId, section: 'technicalApplication' }
            });
            window.open(routeData.href, "_blank");
        } else {            
            this.$router.push({
                name: "applSummary",
                params: { applicationId: applicationId }
            });
        }
    }

     /** Download Pdf*/
    downloadPdf(item: any) {
        let self = this;
        let categoryList = [], modelData, formData;
        if(item.ExternalReviewId) {
            this.$services.review.getReportData(item.ExternalReviewId, item.Entity)
            .then((resp) => {
                if(resp.status >= 200 && resp.status < 300) {
                    this.getCategories({ id: resp.data.metadata.ApplicationId, entity: item.Entity })
                    .then((catg) => {
                        this.$services.tagReviewReport.generate({
                        "data": resp.data.review,
                        "categories": catg,
                        "metadata": resp.data.metadata,
                        "user": this._username
                        });
                    })                
                }
            });        
        }
    }

    /** Review the application */
    reviewApplication(item) {
        const self = this;
        if(item.ExternalReviewId){
            this.setReviewId(item.ExternalReviewId);
            this.$router.push({
                name: "reviewApplication"
            });
        } else {
            self
            .createReview({ ApplicationId: item.ApplicationId })
            .then((data: any) => {
                if(data && data.ExternalReviewId){
                this.setReviewId(data.ExternalReviewId);
                this.$router.push({
                    name: "reviewApplication"
                });
                }        
            });
        }    
  }

    getFormData(model) {
    const reviews = Object.keys(model).reduce(
      (out: any, key: string) => {
        out.push(
          Object.assign({}, { categoryId: parseInt(key) }, model[key])
        );
        return out;
      },
      []
    );
    let form = {
      reviews,
      override: this.review.override,
      comment: this.review.comment,
      // totalScore: this.overallScore,
      overallRating: this.review.overallRating,
      recommendation: this.review.recommendation,
      applicationId: this.review.applicationId,
      reviewerId: this.review.reviewerId,
      version: this.review.version,
      auditInfo: this.review.auditInfo
    };

    return form;
  }

  formatCurrency(val) {
      return utils.formatCurrency(val, this.application.application.BudgetCurrency, this.defaultLocale);
  }  
    

    /** watch method */
    @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any) {
        if(changedRoute && changedRoute.name === 'reviewSummary') {
            if(this.application && this.application.selectedApplication) {
                this.id = this.application.selectedApplication;
                this.tagReviews = [];
                this.getApplication(this.application.selectedApplication).then((data) => {
                    this.$services.review.getReviewSummary(this.application.selectedApplication, "").then((resp) => {
                        if(resp.Result && resp.Result === 'OK') {
                            this.tagReviews = resp.Record;
                        }
                    });
                });
            }  
        }        
    }

}
